import { Link } from "react-router-dom";
import { FiCalendar } from "react-icons/fi";

export default function BlogCard({ blog, isMarginBottom, inSlider }) {
  const formattedDate = new Date(blog.date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const displayTitle = blog.cardTitle || blog.title;

  return (
    <div
      key={blog._id}
      className={
        inSlider
          ? "blog-card-slide"
          : `col-md-6 col-lg-4 d-flex ${isMarginBottom ? "mb-4" : ""}`
      }
    >
      <Link
        to={blog.link}
        className="blog-card-link"
        onClick={() => window.scrollTo(0, 0)}
      >
        <article
          className={`post ${inSlider ? "post--slider" : ""}`}
          {...(!inSlider && {
            "data-aos": "fade-up",
            "data-aos-delay": "300",
            "data-aos-once": "true",
          })}
        >
          <figure className="feature-image blog-card-image">
            <img src={blog.image} alt={blog.title} />
          </figure>
          <div className="entry-content blog-card-content">
            <h3 className="entry-title blog-card-title">{displayTitle}</h3>
            <div className="entry-meta blog-card-meta">
              <span className="posted-on blog-card-date">
                <FiCalendar className="blog-card-date-icon" aria-hidden="true" />
                {formattedDate}
              </span>
            </div>
          </div>
        </article>
      </Link>
    </div>
  );
}
